import { useReviewState, useAuthState } from '@core/configureStore';
import React, { useEffect, useMemo } from 'react';
import DashboardScreen from './DashboardScreen';
import WelcomeHomeScreen from './WelcomeHomeScreen';
import LoadableContainer from '@components/LoadableContainer';
import SplashScreen from '@components/SplashScreen';
import { useIntercom, DataAttributes } from 'react-use-intercom';

type Props = {};

const HomeScreen = (props: Props) => {
  const { reviewResponse, isLoading } = useReviewState();
  const { update } = useIntercom();
  const { user } = useAuthState();
  const hasReviewData = useMemo<boolean>(
    () => reviewResponse?.reviews.length > 0,
    [reviewResponse]
  );

  useEffect(() => {
    if (user) {
      let intercomData: DataAttributes = {
        email: user.email,
        userId: user.id.toString(),
        name: `${user.given_name} ${user.family_name}`,
      };

      if (user.selected_location) {
        intercomData = {
          ...intercomData,
          customAttributes: {
            Location: user.selected_location.title,
          },
        };
      }
      update(intercomData);
    }
  }, [user]);

  return (
    <LoadableContainer isLoading={isLoading} loadComponent={<SplashScreen />}>
      {hasReviewData ? <DashboardScreen /> : <WelcomeHomeScreen />}
    </LoadableContainer>
  );
};

export default HomeScreen;
